export const toPascalCaseWithSpaces = (str) => {
    if (typeof str !== 'string') {
        throw new TypeError('Input must be a string');
    }
    return str
        .replace(/([A-Z0-9_\- ])/g, ' $1') // Add space before each uppercase letter or number
        .trim(); // Remove any leading/trailing spaces
};

// Example usage:
// console.log(toPascalCaseWithSpaces('UnlistedSecuritisedDebtInstrument'));
// Output: 'Unlisted Securitised Debt Instrument'
// console.log(toPascalCaseWithSpaces('Unlisted4SecuritisedDebtInstrument'));
// Output: 'Unlisted 4 Securitised Debt Instrument'
